import { render, staticRenderFns } from "./MultiAutoComplete.vue?vue&type=template&id=b3b88a0a&"
import script from "./MultiAutoComplete.vue?vue&type=script&lang=js&"
export * from "./MultiAutoComplete.vue?vue&type=script&lang=js&"
import style0 from "./MultiAutoComplete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports